import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { useAsync } from 'react-async';
import { useIntl } from 'react-intl';
import { UploadFile } from './UploadFile';

export const ValidateAndUpload = ({
  file,
  onReset,
  validateFn,
  importFn,
  renderPreview,
}: {
  file: File;
  onReset: () => void;
  validateFn: () => Promise<any>;
  importFn: () => Promise<any>;
  renderPreview: (data: any) => void;
}) => {
  const { $t } = useIntl();
  const query = useAsync({
    promiseFn: validateFn,
  });

  return (
    <>
      {query.error && (
        <Alert severity="error" sx={{ fontSize: 'medium' }} onClose={onReset}>
          <AlertTitle>
            {$t({
              id: 'validateUpload.verifyError',
              defaultMessage: 'Ocurrió un error al verificar el archivo',
            })}
          </AlertTitle>
          {(query.error as Error).message}

          <Box mt={3}>
            <Button color="inherit" variant="outlined" size="small" onClick={onReset}>
              {$t({
                id: 'validateUpload.tryAgain',
                defaultMessage: 'Intentar de nuevo',
              })}
            </Button>
          </Box>
        </Alert>
      )}

      {query.data && (
        <>
          <Box mb={2}>
            <strong>
              {$t({
                id: 'validateUpload.fileLabel',
                defaultMessage: 'Archivo:',
              })}{' '}
            </strong>
            {file.name}
          </Box>
          <UploadFile importFn={importFn} onReset={onReset} />
          {renderPreview(query.data)}
        </>
      )}
    </>
  );
};
